// Copyright (c) 2022 by Move Closer

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const creationsCarouselConfig = {
  autoplay: false,
  centralize: false,
  delay: 2000,
  hasPagination: false,
  hasButtons: false,
  initialSlide: 0,
  inLoop: false,
  pauseOnHover: false,
  perPage: 2.2
}
